var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavOffersHome = function SvgNavOffersHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nav_offers_home_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".nav_offers_home_svg__st0{fill:none;stroke:#666;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_offers_home_svg__home"
  }, /*#__PURE__*/React.createElement("path", {
    className: "nav_offers_home_svg__st0",
    d: "m15.9 22 8.4-6 8.2 6M19 19.4V16h1.9v2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "nav_offers_home_svg__st0",
    d: "M16.9 21.4v9.7h14.6v-9.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "nav_offers_home_svg__st0",
    d: "M21.9 30.7v-6.9h4.4v6.9"
  }))));
};
export default SvgNavOffersHome;